export const lightTheme = {
    isDark: false,
    background: '#fff',
    text: '#414141',
    card: '#f1f1f1',
    border: '#e1e1e1',
    primary: '#3075FA',
    shadow: '#00000040',
    warning: '#ff810b'
}

export const darkTheme = {
    isDark: true,
    background: '#131517',
    text: '#fff',
    card: '#1E1F25',
    border: '#585b63',
    primary: '#3075FA',
    shadow: '#ffffff40',
    warning: '#ff810b'
}